import { PerfilService } from 'src/app/services/perfil.service'
import {
  MatDialog as MatDialog,
  MatDialogRef as MatDialogRef,
  MAT_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/dialog'
import { Component, Inject } from '@angular/core'
import { FormControl, Validators } from '@angular/forms'
import { UnespCoreMessageService } from '@unesp/core'
import { IncluirUsuarioPerfil } from 'src/app/models/perfil'

export interface AdicionarDialogData {
  idPerfil: number
}

@Component({
  selector: 'app-adiciona-perfil.component',
  templateUrl: './adiciona-perfil.component.html',
  styleUrls: ['./adiciona-perfil.component.css'],
  standalone: false
})
export class PropgAdicionaPerfilComponent {
  novoUsuario?: IncluirUsuarioPerfil
  email: string = ''
  idPerfil?: number

  identificacaoFC: FormControl = new FormControl('', Validators.required)

  constructor(
    private perfilService: PerfilService,
    private unespCoreMessageService: UnespCoreMessageService,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: AdicionarDialogData,
    public dialogRef: MatDialogRef<PropgAdicionaPerfilComponent>
  ) {}

  salvar(): void {
    if (!this.identificacaoFC.valid) {
      this.unespCoreMessageService.showMessageError('Erro ao preencher os dados do formulário')
      return
    }
    if (this.data.idPerfil) {
      this.perfilService.adicionarUsuario(this.data.idPerfil, this.identificacaoFC.value).subscribe(value => {
        if (value) {
          this.unespCoreMessageService.showMessageSuccess(
            `Perfil ${this.data.idPerfil} aplicado com sucesso ao usuário ${this.identificacaoFC.value}`
          )
          this.dialogRef.close(true)
        } else this.identificacaoFC.setErrors({ invalido: true })
      })
    }
  }

  cancelar(): void {
    this.dialogRef.close(false)
  }
}
